// These versions should be the version that the deprecation was _introduced_,
// not the version that the feature will be removed.

/** Introduced in 4.0.0-beta.1 */
export const ASSIGN = true;
